module.exports = __webpack_public_path__ + "img/404icon.b6136861.svg";